import { useCallback } from 'react';
import { useProgress } from '@/contexts/ProgressContext';

interface UseJournalResult {
  note: string;
  setNote: (next: string) => void;
}

/** Per-ticket journal note. Auto-saves to localStorage via ProgressContext. */
export function useJournal(ticketId: string): UseJournalResult {
  const { getTicket, setNote } = useProgress();
  const tp = getTicket(ticketId);
  const note = tp?.note ?? '';

  const writeNote = useCallback(
    (next: string) => {
      setNote(ticketId, next);
    },
    [setNote, ticketId],
  );

  return { note, setNote: writeNote };
}
